import { Layout } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import AdaptiveDrawer from "../general/drawer/AdaptiveDrawer";
import ProtectedRoute from "../general/ProtectedRoute";
import { nonSubmenuRoutes, routes } from "../general/Routes";
import "./Home.css";
import NormalLoginForm from "../logIn/NormalLoginForm";

const { Header, Sider } = Layout;
const breakpoints = {
  desktop: 1040,
  tablet: 840,
  mobile: 540
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("home");
  }

  render() {
    let drawerRoutesArray = routes.reduce((routesArray, routeCategory) => {
      return routesArray.concat(routeCategory.subRoutes);
    }, []);
    if(this.props.context.session_id==""){
     return <NormalLoginForm/>
    }
    return (
      <AdaptiveDrawer>
        <Layout
          style={
            this.props.context.curr_dir
              ? { padding: 20, paddingLeft: 50 }
              : { padding: 20, paddingRight: 50 }
          }
        >
          {drawerRoutesArray.map((route, index) => (
            <ProtectedRoute
              key={index}
              path={`/home/${route.key}`}
              component={route.component}
              privileges={route.privileges}
              access={route.access}
              exact
            />
          ))}
          {nonSubmenuRoutes.map((route, index) => (
            <ProtectedRoute
              key={index}
              path={`/home/${route.key}`}
              component={route.component}
              privileges={route.privileges}
              access={route.access}
            />
          ))}
        </Layout>
      </AdaptiveDrawer>
    );
  }
}

export default withSharedStateConsumer(withRouter(Home));
